import React from "react";
import Select from "react-select";
import { FormGroup } from "reactstrap";

import {
  BookingWindow,
  BOOKING_WINDOW_VALUES,
} from "../../../../api/graphql/workplaces";
import { selectStyles } from "../../../../lib/utils/selectStyles";
import { InputDescription } from "../../InputDescription/InputDescription";
import { LabelWithInformationBox } from "../../LabelWithInformationBox/LabelWithInformationBox";

import "./BookingWindowField.scss";

interface Props {
  type: "room" | "desk";
  value: BookingWindow;
  onChange: (value: BookingWindow) => void;
}

type BookingWindowOption = { label: string; value: BookingWindow };

const bookingWindowOptions: BookingWindowOption[] = BOOKING_WINDOW_VALUES.map(
  (value) => ({
    label: `${value} days`,
    value,
  })
);

export const BookingWindowField = ({ type, value, onChange }: Props) => {
  const description =
    type === "room"
      ? "Sets the maximum booking window for this room in GOGET. Global default: 180 days. This override only applies to bookings made through GOGET. Calendar events may still be visible beyond the limit, but users cannot create bookings past the configured number of days. Booking window restrictions configured in the calendar provider always override this setting."
      : "Sets the maximum booking window for this desk. Global default: 180 days. Desk reservations may still be visible beyond the limit, but users cannot create bookings past the configured number of days.";

  return (
    <FormGroup className="BookingWindowField">
      <div className="BookingWindowField__row">
        <LabelWithInformationBox
          title="Booking window"
          for={`${type}BookingWindow`}
          message={`Sets the maximum booking window for this ${type}.`}
        />
        <div className="BookingWindowField__select">
          <Select<BookingWindowOption, false>
            inputId={`${type}BookingWindow`}
            options={bookingWindowOptions}
            theme={selectStyles}
            name={`${type}BookingWindow`}
            isMulti={false}
            isSearchable={false}
            isClearable={false}
            onChange={(option) => {
              if (!option) {
                return;
              }

              onChange(option.value);
            }}
            value={
              bookingWindowOptions.find((option) => option.value === value) ||
              bookingWindowOptions[5]
            }
          />
        </div>
      </div>
      <InputDescription
        icon="warning-triangle"
        description={description}
        className="BookingWindowField__description"
      />
    </FormGroup>
  );
};
